// Client-side like helpers. These are a UX/cost optimization only — the real dedup
// is the server-side wall_likes(post_id, device_id) PK. localStorage lets us gray-out
// already-liked cards and skip the network call entirely (saving D1 requests).

const DEVICE_KEY = "wishes:device_id";
const LIKED_KEY = "wishes:liked";

/** Stable random id for this browser; lazily created and persisted. */
export function getDeviceId(): string {
  let id = localStorage.getItem(DEVICE_KEY);
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem(DEVICE_KEY, id);
  }
  return id;
}

function likedSet(): Set<string> {
  try {
    return new Set(JSON.parse(localStorage.getItem(LIKED_KEY) ?? "[]"));
  } catch {
    return new Set();
  }
}

export function hasLiked(id: string): boolean {
  return likedSet().has(id);
}

export function markLiked(id: string): void {
  const s = likedSet();
  s.add(id);
  localStorage.setItem(LIKED_KEY, JSON.stringify([...s]));
}
